export default {
  index: [
    {
      path: '/fwwutype',
      component: resolve => require(['./fwwutypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/fuwutype/_router.js